module.exports = __webpack_public_path__ + "static/img/phone-CA.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-CA.png
// module id = x57x
// module chunks = 1